import { IClassroomResource } from "../../classrooms";
import { ITagResource } from "../../tags";
import {
    createApiQueryHook,
    IApiQueryFunction,
    IOrderable,
    IPaginateable,
    mapOrder,
    mapPagination,
} from "../../utils/api";
import { mapRelationalFilter, RelationalFilter } from "../../utils/filters";
import { serialize } from "../../utils/url";
import { IResourceList } from "../types";

export interface IResourceListQueryParameters extends IPaginateable, IOrderable<"title" | "createdAt"> {
    filters?: {
        term?: string;
        title?: string;
        description?: string;
        classroom?: RelationalFilter<IClassroomResource>;
        tags?: RelationalFilter<ITagResource>;
        createdByRoles?: string;
    };
}

export type IResourceListQueryResult = IResourceList;

const mapFilters = (filters: IResourceListQueryParameters["filters"]) => {
    const { term, title, description, classroom, tags, createdByRoles } = filters ?? {};

    return {
        term,
        title,
        description,
        "classroom.uuid": mapRelationalFilter(classroom),
        "tags.uuid": mapRelationalFilter(tags),
        "createdBy.roles": createdByRoles,
    };
};

export const resourceListQuery: IApiQueryFunction<IResourceListQueryParameters> = ({ filters, order, pagination }) => {
    return {
        method: "GET",
        url: `/resources${serialize(
            {
                ...mapPagination(pagination),
                ...mapOrder(order),
                ...mapFilters(filters),
            },
            true,
        )}`,
    };
};

export const useResourceListQuery = createApiQueryHook<IResourceListQueryParameters, IResourceListQueryResult>(
    resourceListQuery,
);
